import { render, staticRenderFns } from "./RecoverPass.vue?vue&type=template&id=32613438&scoped=true&"
import script from "./RecoverPass.vue?vue&type=script&lang=js&"
export * from "./RecoverPass.vue?vue&type=script&lang=js&"
import style0 from "./RecoverPass.vue?vue&type=style&index=0&id=32613438&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32613438",
  null
  
)

export default component.exports